import { WebPlugin } from '@capacitor/core';
export class VpnDetectorWeb extends WebPlugin {
    async isVpnActive() {
        throw this.unimplemented('VPN detection is not available on web platform');
    }
}
//# sourceMappingURL=web.js.map